import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';


@Injectable({
  providedIn: 'root'
})
export class SeguimientoService {

  constructor(private http: HttpClient, private config: ConfigService) { }


  getVenta(idVenta: number) {
    const url = this.config.urlService + "api/Seguimiento/Venta/" + idVenta;
    return this.http.get(url);
  }

  getVentasRegistro(token: String, dateIni: string, dateFin: string) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Seguimiento/Registro/" + dateIni + "/" + dateFin;
    return this.http.get(url, requestOptions);
  }

  /*  getVentasSales(token: String, dateIni: string, dateEnd: string,){
     const requestOptions = new Object({
       headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
     });
     const url = this.config.urlService + "api/Seguimiento/Ventas/" + date;
     return this.http.get(url, requestOptions);
   }
  */
  getVentasDiscriminacionPago(token: string, dateIni: string, dateEnd: string, idEmpleadoProveedor: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Seguimiento/Pagos/" + dateIni + "/" + dateEnd + "/" + idEmpleadoProveedor;
    return this.http.get(url, requestOptions);
  }


  getVentasDiscriminacionVendedor(token: String, dateIni: string, dateEnd: string) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Seguimiento/VentaVendedores/" + dateIni + "/" + dateEnd;
    return this.http.get(url, requestOptions);
  }

  getVentasDiscriminacionVenta(token: String, dateIni: string, dateEnd: string) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Seguimiento/DetalleVenta/" + dateIni + "/" + dateEnd
    return this.http.get(url, requestOptions);
  }

  getDetalleVentasAcumuladoDesc(token: String, dateIni: string, dateEnd: string, idProveedor: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Seguimiento/DetalleVentaAcumuladoDesc/" + dateIni + "/" + dateEnd + "/" + idProveedor;
    return this.http.get(url, requestOptions);
  }

  getDetalleVentasAcumuladoAsc(token: String, dateIni: string, dateEnd: string, idProveedor: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Seguimiento/DetalleVentaAcumuladoAsc/" + dateIni + "/" + dateEnd + "/" + idProveedor;
    return this.http.get(url, requestOptions);
  }



}
